import { FC, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Routes from '@/router/Routes';

function getYouTubeThumbnail(url: string | null | undefined): string | null {
  if (!url) return null;
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/);
  return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : null;
}

interface LessonBoxProps {
  id: string;
  title: string;
  subject: string;
  date: string;
  videoUrl?: string | null;
}

export const LessonBox: FC<LessonBoxProps> = ({ id, title, subject, date, videoUrl }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const thumbnail = useMemo(() => getYouTubeThumbnail(videoUrl), [videoUrl]);

  return (
    <div className="bg-white rounded-3xl w-[280px] flex flex-col gap-4">
      <div 
        className="h-[160px] rounded-tr-3xl rounded-tl-3xl overflow-hidden bg-gradient-to-br from-blue-50 to-blue-100 relative"
      >
        {thumbnail ? (
          <img 
            src={thumbnail} 
            alt={title} 
            className="w-full h-full object-cover hover:opacity-90 transition-opacity"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" className="text-blue-300 opacity-50">
              <path d="M8 5v14l11-7z" fill="currentColor"/>
            </svg>
          </div>
        )}
      </div>
      <div className="p-4 rounded-br-3xl rounded-bl-3xl">
        <div className="flex flex-col gap-1">
          <h3 className="text-2xl font-bold text-gray-900">{title}</h3>
          <p className="text-gray-600">{subject}</p>
          <p className="text-gray-500 text-sm">{date}</p>
        </div>

        <button 
          onClick={() => navigate((isAdmin ? Routes.ADMIN_LESSON_DETAILS : Routes.LESSON_DETAILS).replace(':id', id))}
          className="w-full mt-[22px] py-3 px-4 bg-[#EEF1FE] rounded-full text-[#4E7DF6] font-medium hover:bg-[#E8EDFF] transition-colors"
        >
          Lesson details
        </button>
        {isAdmin && (
          <button 
            onClick={() => navigate(Routes.ADMIN_EDIT_LESSON.replace(':id', id))}
            className="w-full mt-2 py-3 px-4 bg-[#FEEEEE] rounded-full text-[#E8573A] font-medium hover:bg-[#FDE3E3] transition-colors"
          >
            Edit content
          </button>
        )}
      </div>
    </div>
  );
}; 